import React, { useState, useEffect, useRef } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { fetchDefault, fetchPostDefault } from './Utils.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backAbsolute: {
        position: 'fixed',
        bottom: theme.spacing(5),
        right: theme.spacing(5),
    },
}));

const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

    return [htmlElRef, setFocus]
}

export default function FindIdPw(props) {
    const classes = useStyles();
    let history = useHistory();

    const [btnRef, setBtnFocus] = useFocus();

    //Form
    const [memberId, setMemberId] = React.useState('');
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('010');

    //Validate
    const [memberIdErrorText, setMemberIdErrorText] = React.useState('');
    const [passwordErrorText, setPasswordErrorText] = React.useState('');
    const [passwordConfirmErrorText, setPasswordConfirmErrorText] = React.useState('');
    const [phoneErrorText, setPhoneErrorText] = React.useState('');

    const [completeOpen, setCompleteOpen] = React.useState(false);
    const [termsOpen, setTermsOpen] = React.useState(false);
    

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            history.push('/display/connected');
        }, 300000);

        return () => {
            clearTimeout(pageTimeout);
        }
    }, []);



    const joinMember = (event) => {

        event.preventDefault();

        if (currentPassword !== confirmPassword) {
            alert('비밀번호가 동일하지 않습니다.');
            return;
        }

        //회원가입
        fetchPostDefault('/User/Join',
            {
                LoginId: memberId,
                Password: currentPassword,
                Phone: phoneNumber
            },
            (data) => {
                //로그인
                fetchPostDefault('/User/Login',
                    {
                        LoginId: memberId,
                        Password: currentPassword
                    },
                    (data) => {
                        //props.loginComplete();
                        setCompleteOpen(true);
                    }
                );
                
            }
        );
    };

    const moveToOccupySeat = () => {
        setCompleteOpen(false);
        window.location.assign('/');
    };

    const validateMemberId = (event) => {

        if (event.target.value.length < 1) {
            setMemberIdErrorText('아이디를 입력해주세요.');
            return;
        }

        //아이디 중복체크
        fetchDefault('/User/CheckIdDuplication?loginId=' + memberId,
            (data) => {
                setMemberIdErrorText('');
            },
            (error) => {
                setMemberIdErrorText(error.message);
            }
        );
    };

    const validatePassword = (event) => {

        setCurrentPassword(event.target.value);

        //패스워드 확인 부분
        if (currentPassword.length > 0 && confirmPassword.length > 0 && event.target.value === confirmPassword) {
            setPasswordConfirmErrorText('');
        } else if (currentPassword.length > 0 && confirmPassword.length > 0 && event.target.value !== confirmPassword) {
            setPasswordConfirmErrorText('비밀번호가 동일하지 않습니다.');
        }

        if (event.target.value.length < 1) {
            setPasswordErrorText('비밀번호를 입력해주세요.');
        }
        else if (event.target.value.length < 4) {
            setPasswordErrorText('비밀번호는 4자리 이상으로 설정해주세요');
        }
        else {
            setPasswordErrorText('');
        }
    };

    const validatePasswordConfirm = (event) => {

        setConfirmPassword(event.target.value)

        if (currentPassword !== event.target.value) {
            setPasswordConfirmErrorText('비밀번호가 동일하지 않습니다.');
        } else {
            setPasswordConfirmErrorText('');
        }
    };

    const validatePhone = (event) => {
        if (event.target.value.length < 10) {
            setPhoneErrorText('핸드폰 번호를 확인해주세요.');
        } else {
            setPhoneErrorText('');
        }
    };

    const setOnlyNumber = (event) => {

        setPhoneNumber((event.target.validity.valid && event.target.value.length < 12) ? event.target.value : phoneNumber);

        if (event.target.value.length == 11) {
            setBtnFocus();
        }
    };

    return (
        <Container component="main" maxWidth="xs">


            <div className={classes.paper}>
                <CssBaseline />
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    회원가입
                </Typography>

                <form onSubmit={joinMember} className={classes.form} noValidate>
                    <Typography component="h6" align='center'>간단한 회원가입 후 모든 시설을 이용할 수 있습니다.</Typography>
                    <Grid container spacing={2} style={{ paddingTop: 10, paddingBottom: 5}}>
                        <Grid item xs={12}>
                            <TextField
                                onBlur={validateMemberId}
                                onChange={(event) => setMemberId(event.target.value)}
                                variant="outlined"
                                required
                                fullWidth
                                id="memberId"
                                label="아이디"
                                name="memberId"
                                error={memberIdErrorText.length === 0 ? false : true}
                                helperText={memberIdErrorText}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                onBlur={validatePassword}
                                onChange={(event) => setCurrentPassword(event.target.value)}
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="비밀번호"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                error={passwordErrorText.length === 0 ? false : true}
                                helperText={passwordErrorText}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                onBlur={validatePasswordConfirm}
                                variant="outlined"
                                required
                                fullWidth
                                name="passwordConfirm"
                                label="비밀번호 확인"
                                type="password"
                                id="passwordConfirm"
                                autoComplete="current-password"
                                error={passwordConfirmErrorText.length === 0 ? false : true}
                                helperText={passwordConfirmErrorText}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                onBlur={validatePhone}
                                onChange={setOnlyNumber}
                                variant="outlined"                                
                                fullWidth
                                id="phone"
                                label="핸드폰 번호('-' 빼고 숫자만 입력)"
                                name="phone"
                                type="number"
                                inputProps={{ pattern: "[0-9]*" }}
                                value={phoneNumber}
                                error={phoneErrorText.length === 0 ? false : true}
                                helperText={phoneErrorText}
                            >
                            </TextField>
                        </Grid>
                    </Grid>
                    <p>※ 핸드폰 번호를 정확히 입력해주세요.</p>
                    <Button
                        onClick={joinMember}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        ref={btnRef}
                        className={classes.submit}
                    >
                        가입하기
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link href="/signIn" variant="body2">
                                이미 회원이신가요? Login →
                            </Link>
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end" style={{ marginTop: 10 }}>
                        <Grid item onClick={() => setTermsOpen(true)}>
                                  회원가입함으로써 <u>이용약관</u> 및 <u>개인정보 취급방침</u>에 동의합니다.
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>
            </Box>

            <Dialog
                open={completeOpen}
                onClose={moveToOccupySeat}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        회원가입이 완료되었습니다!
                    </Typography>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 10 }}>
                        다음 화면에서 자리를 선택해서 사용할 수 있습니다!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={moveToOccupySeat}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={termsOpen}
                onClose={() => setTermsOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="body2" color="textPrimary">
                        <p>
                            개인정보 처리방침
                        </p>
                            개인정보의 처리 목적
                        <p>
                            24시 스터디카페 은(는) 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.
                        </p>
                        <p>
                            - 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본신 식별 및 인증, 회원자격 유지 및 관리, 물품이나 서비스 공급에 따른 금액 결제, 물품 또는 서비스의 공급 및 배송 등
                        </p>
                        <p>
                            개인정보의 처리 및 보유 기간
                        </p>
                        <p>
                            1) 24시 스터디카페 는 정보 주체로 부터 개인정보를 수집할 때 동의 받은 개인정보 보유 이용기간 또는 법령에 따른 개인정보 보유, 이용기간 내에서 개인정보를 처리 및 보유 합니다.
                        </p>
                        <p>
                            2) 구체적인 개인정보 보유 기간은 다음과 같습니다.
                        </p>
                        <p>
                            - 고객가입 및 관리 : 서비스 이용 계약 또는 회원가입 해지시 까지
                        </p>
                        <p>
                            개인정보의 제3자 제공에 관한 사항
                        </p>
                        <p>
                            1) 24시 스터디카페는 정보주체의 동의, 법률의 특별한 규정등 개인정보 보호법 제 17조 및 18조에 해당하는 경우에만 개인정보를 제 3자에게 제공합니다.
                        </p>
                        <p>
                            2) 24시 스터디카페는 다음과 같이 개인정보를 제 3자에게 제공하고 있습니다.
                        </p>
                        <p>
                            - 개인정보를 제공받는 자 : 없음.
                        </p>
                        <p>
                            개인정보처리 위탁
                        </p>
                        <p>
                            ① 24시 스터디카페 는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
                        </p>
                        <p>
                            위탁없음.
                        </p>
                        <p>
                            - 위탁받는 자 (수탁자) : 없음.
                        </p>
                        <p>
                            - 위탁하는 업무의 내용 : 없음.
                        </p>
                        <p>
                            - 위탁기간 : 없음.
                        </p>
                        <p>
                            ② 24시 스터디카페 은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                        </p>
                        <p>
                            ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                        </p>
                        <p>
                            정보주체와 법정대리인의 권리·의무 및 그 행사방법 이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.
                        </p>
                        <p>
                            ① 정보주체는 24시 스터디카페 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
                        </p>
                        <p>
                            1. 개인정보 열람요구
                        </p>
                        <p>
                            2. 오류 등이 있을 경우 정정 요구
                        </p>
                        <p>
                            3. 삭제요구
                        </p>
                        <p>
                            4. 처리정지 요구
                        </p>
                        <p>
                            처리하는 개인정보의 항목 작성
                        </p>
                        <p>
                            ① 24시 스터디카페 은(는) 다음의 개인정보 항목을 처리하고 있습니다.
                        </p>
                        <p>

                            - 필수항목 : 아이디, 전화번호.
                        </p>
                        <p>
                            - 선택항목 : 없음.
                        </p>
                        <p>
                            개인정보의 파기
                        </p>
                        <p>
                            24시 스터디카페는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
                        </p>
                        <p>
                            -파기절차
                        </p>
                        <p>
                            이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                        </p>
                        <p>
                            -파기기한
                        </p>
                        <p>
                            이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                        </p>
                        <p>
                            개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항
                            24시 스터디카페는 정보주체의 이용정보를 저장하고 수시로 불러오는 '쿠키'를 사용하지 않습니다.
                            정보 주체가 제3자인 구글에게 제공하는 정보는 24시 스터디카페와 상관없이 정보 주체 기기상의 구글 설정에 따릅니다.
                        </p>
                        <p>
                            개인정보 보호책임자 작성
                        </p>
                        <p>
                            ① 24시 스터디카페는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                        </p>
                        <p>
                            ▶ 개인정보 보호책임자
                        </p>
                        <p>
                            24시 스터디카페 대표 홍정우 (이메일 : waterwark@gmail.com)
                        </p>
                        <p>
                            개인정보 처리방침 변경
                        </p>
                        <p>
                            ①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
                        </p>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setTermsOpen(false)}>
                        <Typography variant="h6">
                            동의
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}


// WEBPACK FOOTER //
// ./src/components/SignUp.js